import React, { useCallback, useContext } from "react";

import { FormContext } from "../../contexts/FormContext";

type ChangeEvent = React.ChangeEvent<HTMLInputElement> & { checked: boolean };

type Props = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type" | "onChange"
> & {
  onChange: (e: ChangeEvent) => void;
};

const CheckboxInput: React.FC<React.PropsWithChildren<Props>> = ({
  disabled,
  onChange,
  ...props
}) => {
  const form = useContext(FormContext);

  const onChangeInternal = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = !props.checked;
      onChange?.({ ...e, checked });
    },
    [onChange, props.checked],
  );

  return (
    <input
      {...props}
      type="checkbox"
      disabled={disabled ?? form.disabled}
      onChange={onChangeInternal}
    />
  );
};

export default CheckboxInput;
